import { createSelector } from 'reselect'
import { Store } from '../../types'

export const contextSelector = (store: Store) => store.context

export const valuationAdjustmentsSelector = createSelector(contextSelector, context => context.valuationAdjustments)
